/**
 * 活动方式
 */
export var ACTIVITYWAY = {
  // 拼团
  groupon: 'ACTIVITY_GROUPON',
  // 秒杀
  seckill: 'ACTIVITY_SECKILL',
  // 表单
  survey: 'ACTIVITY_SURVEY',
  original: 'ACTIVITY_BUY_SEPARATELY'
};

/**
 * 活动计划版本
 */
export var PLANVERSION = {
  NotLinkToIndex: 'JUMP_NO_INDEX'
};
export var INTERACTION_LIST = [{
  label: '锚点',
  value: 'anchor'
}, {
  label: '弹窗',
  value: 'modal'
}, {
  label: '订单确认页',
  value: 'confirm'
}];
export var CONFIRM_MAP = {
  y: '跳转',
  n: '不跳转'
};
export var CONFIRM_SETTING = [{
  label: '跳转',
  value: 'y'
}, {
  label: '不跳转',
  value: 'n'
}];

// swiper类型组件
export var COMP_TYPE_SWIPER = 'swiper';
export var INTERACTION_TITLE_LIST = ['anchor', 'modal', 'confirm'];

/**
 * 商品类型对应上课按钮内容
 */
export var ProductTypeBtnTexts = {
  0: '立即报名',
  1: '去学习',
  2: '去上课',
  3: '去查看',
  4: '去查看',
  5: '待开始',
  6: '登录',
  7: '已结束'
};
// 屏蔽支付宝支付
export var ShieldingAlipayProjects = [100535968 /* 量化CTA */, 100535969 /* 职业兴趣 */, 1000632 /* CPA */, 1000645 /* 中级职称 */, 100520929 /* 公务员 */, 1000054 /* CFA */, 100520945 /* 在职研 */, 100534842 /* 军队文职 */, 100523443 /* 事业单位 */, 2012842 /* 考研 */];
export var ShieldingAlipayChannelId = [4567 /* 今日头条 */, 4563 /* 抖音广告 */];
export var defaultNavList = [{
  title: 'tab1',
  target: undefined
}, {
  title: 'tab2',
  target: undefined
}];
export var defaultImageList = [{
  backgroundImage: 'https://t-simg01.gaodunwangxiao.com/uploadfiles/me-design/202411/11/f87f7_20241111194345.png',
  switchType: 'url'
}];
export var alignOptions = [{
  label: '居左',
  value: 'left'
}, {
  label: '居中',
  value: 'center'
}, {
  label: '居右',
  value: 'right'
}];
export var eventTypeOptions = [{
  label: '普通跳转',
  value: 'default'
}, {
  label: '秒杀活动',
  value: 'seckill'
}, {
  label: '抽奖活动',
  value: 'lottery'
}, {
  label: '视频号预约',
  value: 'video'
}, {
  label: '小程序订阅',
  value: 'subscribe'
}, {
  label: '在线咨询',
  value: 'online_consultation'
}, {
  label: '领取优惠券',
  value: 'coupon'
}];

// 订阅模版列表
export var subscribeTemplateList = [{
  label: '好友助力通知订阅',
  value: 'frendHelp'
}, {
  label: '获取资源唤起订阅',
  value: 'materialGet'
}, {
  label: '拼团订阅消息',
  value: 'grouponStatus'
}, {
  label: '优惠券订阅信息',
  value: 'couponGet'
}, {
  label: '好友助力通知订阅(助力活动)',
  value: 'friendsHelpAssistance'
}, {
  label: '获取资源长期订阅',
  value: 'longTerm'
}, {
  label: '速记卡订阅',
  value: 'shorthand'
}, {
  label: '预约估分订阅',
  value: 'reserveEstimateScore'
}, {
  label: '估分报告订阅',
  value: 'estimatePaper'
}, {
  label: '连续签到订阅',
  value: 'continuousSign'
}, {
  label: '挑战赛 预约下一期',
  value: 'clockinmatchSubscribeNextRound'
}, {
  label: '挑战赛 立即加入',
  value: 'clockinmatchPartIn'
}, {
  label: '专题页 邀请有礼',
  value: 'specialPageInviteFriends'
}, {
  label: '采分预约订阅',
  value: 'collectionReservate'
}, {
  label: '采分邀请好友订阅',
  value: 'collectionInviteFriends'
}, {
  label: '抽奖任务 消息提醒',
  value: 'lotteryTask'
}];
export var tempListMap = {
  wx5aabe376c8eaae3b: {
    frendHelp: ['ZuwOn4K46XptJd9NS6r26AbIlH8OMa3kcBAoJxUXLrY', 'xLMYSCtCfVVq2jC90hknEuLrLTcfiUILIsqnn0jsFdM', 'HoLPFW9EOU2LcYBwmh73_3w3z7QOky82bf6TMnWw7eg'],
    materialGet: ['an9YMs676RI_V8Ctb8CJ4H1mO3sylqtA3Y4sQL9ELSQ', 'G75GFC4O9wkMjfaBbUQNnvEvPeG7VPNSNjp3ETr_SUE', 'tsMKfHd7Hmap_6_JwfS7SgNvzgdEEnns9txqEYHYbrA']
  },
  wxe0c3c4e5d6b7e100: {
    frendHelp: ['pJ6RfyMoyjciBRAluhTpn7gzkJXpRhY4kkNOEmoyV9A'],
    materialGet: ['Lcxo1ymRz38-9HooMbMGNXVXx4Ljlq06OztxJt-Z9P0', 'ytVVKeU5VhdC20ZQHMPDByC54zE6K6ZGW1pHbXGh0Rg', 'sjBVJqavUz564jt6UKIMCoAYRUGPHxdseNs7j1nDbw0'],
    grouponStatus: ['QVCEcMlcfpMBbCI8IaZ4wRDq75cH1t2ZE04gp95OUPE', 'D9x_rjG0ln0bpkocXHDK8BqbuxSVC0YNxo06W2Pyy8o', 'TJTo88PzqZ1bLfKE_3eO3xC5crtnhpoqdt1Tc5_HP6c']
  },
  wx4bde10728740b727: {
    friendsHelpAssistance: ['Sbcl0wSuaNHBUKea0EkDSkxCJRSSclYAl8dvqlpYlao', 'lZkj-kuq6JUytGuA4zryESYMcUupflH-4r0T4QlJ2J4', '_8ePfwK11Mh7qkCvzeTrHEAOaB3wnfR87XTRsPRbFn8'],
    frendHelp: ['Sbcl0wSuaNHBUKea0EkDSkxCJRSSclYAl8dvqlpYlao', '_8ePfwK11Mh7qkCvzeTrHEAOaB3wnfR87XTRsPRbFn8', 'lZkj-kuq6JUytGuA4zryESYMcUupflH-4r0T4QlJ2J4'],
    materialGet: ['_8ePfwK11Mh7qkCvzeTrHJOHjA9LHBWcvrqwJDU8H9w', 'Mh0A3-tk7DcTllvHJgoiMWMsI6h1q2iBas1YshLyTeE', 'XBfoZBsIRDTFic5-41CcFTpu6MDFa2MM-zaq2EpEF-U'],
    couponGet: ['6BeWd4H7CnOl5KY24DlZMup3xzD4pBq8gOhERA_ht0g', 'KNZcMs8KQGuI-6ea3T8rUzD1sbSdiIF0SEw-1GJJdZA', 'JF7frIVi39eHgUKXHg-a7tg05PsZZKuRtOKGo8ZAuac']
  },
  wxbc81e3d94da0a9fa: {
    frendHelp: ['-uvBuyVOekAgYjrN502DDgLZGwc9MkxzZnGAvy5sSeI'],
    materialGet: ['gBZMyQVB7pv0m6D5wSu1zPH6FnA1Jh86y4XttxPBnMQ', 'hSvvwMaUsGuhWa3wQ5d2lLDRkvXfsANDRNxyd0cctGk', 'aapD0koEdoseV5xKWDi3UKi-hIWwwp5UtMDT01_puIA']
  },
  wx071816c5489a2443: {
    frendHelp: ['Tu_x--Ho1Bl2i-YwmRF281OoaenNMFUvy_rcueC5h3E'],
    materialGet: ['D2J78egbt1RanGW9C0GIGb8MeCLcN3aZiUiyhYQaAp0', 'z8LfLkWL6e31VkxbJUXtXPTBE_LJ32CPyQrgaL581do', 'IaJ-dW2CyOviaESV2rAFPGAls_0swkmCEYzrxL0u49Q']
  },
  wxe67581f6c9cac0c0: {
    frendHelp: ['zKCzFbOZdJh4g-TzzWdyJNFrzJeHm7oSPC4AC3f2Wig', 'cPVrZc5_2EaWaosJ_vc2kcxErMq7WSdXBYXlcgoxdqc', '6rqXWgNuI7ylSg56uv5rkmnn5ZcHFQd4q0xb6k_al5k'],
    materialGet: ['2uw1h0ryOJ5pWf5u6SWHf2AdJ9_dPPTG5r6sAKCyOao', '_UuO_3rpjlyfpnP1rIuoWG8K7JVP66y5k8_8mAhY0dI', 'jcgkIOLGPXhro6XOLnPi38kNNxHUWAEWwFdv4QmvBZ0'],
    longTerm: ['COKnF8xvHeFEgW2m6zVcTxN3kxOyhNjWmpN5_KYa788']
  },
  wxa2363fc06727a4bc: {
    frendHelp: ['tWKnTfD3fL7nIKrSamjw7kzLuoyjf-w2ZahCI4K7fn8'],
    materialGet: ['opnrnvxV9ggUd0DYDHaKMDAVTJSZyVWiJXafLY7zSrY', 'h9A-Mfox-bxVmJ8JTzlzeCUqtJSa2LA9w1TWaPfi70o', 'M9GPcILk5EGEh8W7O8Ioes4v_qsiFFLBGIj3ZpvIBbE']
  },
  wx04364264f6620ecb: {
    frendHelp: ['HXO9mhmW7lRWQNR03CHvHiCzOIJXWAvCiv6sVSC_QXM', '-jTjE4mTzppdfuEi431Xlcen-ro9DNmHXEEZhCB6tFo', 'eaR27O94GTNkbqFqGgPKHtrDcpUrBlc8Aege1VLZNRc'],
    materialGet: ['lbsZUDGWgIR36UZWsxArJz1iVQ0ZxGJQvJHqQHPnG7E', 'xFOCiepWT2W3ybQD1gVNoFsMtBwJXvCFzluhfxlNTQI', 'D23lMp8jYPKthqlNDq8aPM0xq0vcQyetsnUJe2myaUc']
  },
  wx69dec5007c31f140: {
    frendHelp: ['BwJrVxKT1rH85rGKj4obpSAOt8JIzxx0gVONdkgxryg'],
    materialGet: ['txONhFKvYzo94h2rapC3KvAEKzY0hvAs-C0KO8-spBs', 'p0OYEkaCmG1Mmzc-VYektcpqfgFsXTfr5XOVZOoHIsM', 'z_Ze2RZiRKm6UvKQhARQfcbG5Rj9_u3XU3WjQW6mKpA']
  },
  wxe164818e59051cef: {
    frendHelp: ['W6nU1fTSg1ptfzMxyCM7xeqZX5MPeJjRaDc3ZC86X-Y', 'FY4-aA1EGjPvDVjlRdysC3oZ-9JDs0FXYe3Ov2YD8is', 'aEWqG2P65jT0araBgThynKsaiMWYrzmeZYt4PUt3_4s'],
    materialGet: ['tp6so9U42b2utWyvL-d1IgqbMzkWXAMtwa4_Q85mYaU', 'fUEg6loXTcvSuPWd8M0JfINrhEYh9PgZBBEH5UIk4Gw', 'eSOVb4-pBeQTdIbk3o9M8TKGbYYdekSYqeqgJUG_JHE']
  },
  wxbfa2107a0ff90448: {
    frendHelp: ['yI9rE7ujST1BOO854KmhaskP0QYri2hzFPhW_xNxMdE', '1VDED7NdhIHA5b7RH6N6d839n-DnOAuREqXWpp5b2Gs', 'fuFXZLSNngQELSswwLqzHMzeLzSg67sNzQvxleAWGBY'],
    materialGet: ['M7vBbXwdOHYtR_7zhfg_ekgoWgqmrv7Mk_S3n4y7nuQ', 'kZo-mUPV2JqycIZ3sXa7ZmWzg7AgFERQV8TXz4X-ThM', 'TDqeiZ-7YRHeWVQqAfcjp5kzo6hCmKKOm5kecUJ4cj4']
  },
  wxc39c992972b0c7cd: {
    frendHelp: ['BE4s49hyM2LwV0Jbsow90kuLntCSaK-cUMYBMgD00i4'],
    materialGet: ['UKUdIcyQUxjzVqtNlyX3pWpLXvm2tYLPJtgNqj3B4g0', 'HD6iihe8mVkmQ2lbARjecTZZYgJBjfrdXu1-UKUidaY', 'XZvwMULke6Jq6IVKPoH1dw3MHmoRAM1ivheBvrqxUkA']
  },
  wxb83680c3b8c92637: {
    frendHelp: ['ogj2vYWW0b-DhDyACGFC_vAqDXYkPYbq_8dKkt0_c7s', 'KUT_tOQ43GcEvg5Tz-ytVFylWHkVbhcgt58QpNHPYFk', 'p9RleWCX0ykxJvulYPRrocpGlDKNapGAfNmH2iEYA1Y'],
    materialGet: ['TSRc5WovSlxasM6U6U2Fja5u9XPH9exSV8Ef52Ao6g0', 'OoYi-ggWgiHcOY6lNO-yY3jTpi-PkA-2O45L9q_dPGA', 'esKP545aQnjPzixkpzPws7lGeDwQ8MKnEPTgPAh8rPs']
  },
  wx25555c0f6d0dc4df: {
    frendHelp: ['x0V3gWhsqbOHLL92-3j5_0XWemuu77OTeAd61xJcm0A', 'yN0IzTqMINwZdmlTLj-A77Qm9rEudDhFYBYv43_Ft9k', '9kIzSultb4OXutdostIjHkUT6J4Mai234LFV_jbfTG0'],
    materialGet: ['ES8ymUCZCwJVcgjTF_Ma2GWCZ9Vc3uFbponka4Cn9jM', 'JUyIWiWeyS_GV8AIHUsl7B7VDwHOwF8nedRsk3D5DBc', 'HDOIxKPPi9M3L2e9_wSXY25t2riqoKR2xJjsKTKotMw']
  },
  wx9897d3c343755cd3: {
    frendHelp: ['czLopFKHUmF4ppiAIAZk_epeXZIFsYoLIP0cO6lIgu8', 'WNnMsW65EMtKEd4KJF-iTODsAx6hDIB4z9dY2vboLjQ', 'MWfegevbbmnyHp2uFVuvRR9vohdV8kYx3sOhdkkKRuw'],
    materialGet: ['2-l4JEzbsfhwSGnApwvYn_kh6UfOWZXIWP1RcwJMTx8', 'xAFz4Ar9JCXpI_zc7f6yQ8ObRIE4JoZ1hzjrH8DvL4o', '47Z3dFpIopBRrlVmwW9wP72J8tflLCWxCikeg5MOu4E']
  },
  wx53755b3b7106bb08: {
    frendHelp: ['f9XCrnUbSRF2bJ4F7LkTfAN5h7jJQi_-X9KXq5i0BzI'],
    materialGet: ['RLZN5JkEQeJ-g3Nu-4UZp9SDLSN8M--xR1eC60UUS5w', 'n8BLfK9Rlx1NSxoVgMhNx9WpMk8KUULjlCyw6CzF6Tc', 'd3ZmgBuJ_agV3hS2mlo_JQletkqwO1WTLJ__VomNgi8']
  },
  wx88bb24bac2ff0d1d: {
    frendHelp: ['U0BYPBxr2eSfc8CgBtCXuNqa513DGZy66azMK1Ik5sE'],
    materialGet: ['6dkWnertNyQ_IPlxUtVrBleb3sLWeUmPRJRu_g_wgLM', 'XvM80tmw7tIzLI8h8dpG5mwN6u9LRqD6EWC9B3L9do4', 'kdLatwpWG5aG30zwRYSoOLxHGJgKMz9l6qlUMC-l2lo']
  },
  wx3c4030f150bab25a: {
    frendHelp: ['QPzjdGd1-ylbnuQTTWf1BykMADAAUeMHCc0Ael5sr50', 'UpmZbJH1P1An2tInfk60AYNjNt937ecpZLZOglku4eA', 'w6oOGZw-rEfWWq3faAiRiGnGFce8HuB_7diKHlfCO4g'],
    materialGet: ['RqtBFvUGmFZTEhYojz-KFmpJNL7MeEx3IThytLKNN0A', 'km_7HVAKCKBRIwmyi3qybqfhB-JZzk90o_OybYx3jTQ', '8XiXw0UatmTkseKDsVIh-Q6wI7ZfEjZc2Tz5HvgpqwU']
  },
  wx02139c02ed4d6b9b: {
    frendHelp: ['Gn4SNlfVFW0EZOIdJmzxQofgDWV7fyi2XTUamUCFkTk', 'OOTRrOsN8DCNdNYxHkVwdFZZKGth8tnZFq013UqJ9zk', 'gtqduGNuH4Gt-g1CD0hBmaC-xr6QKOiIP2GFu6TFDss'],
    materialGet: ['rvkJYvQCaoeCxZo-6xFZLGexrPAwKrrFRekf8aRMewk', '42vCJoC9kmm7FNKWa5SRmCMo6vc-6bGLVwo6up-XeYg', '4_t7qGP3AoyZvI9N7calgfOqqJcvVoZk4dXoJ4pXyF8']
  },
  wx94785b6a70eda123: {
    frendHelp: ['zsDOqLqccMWXnBxIMEqt0dyRJlxN_0t9SNP6IEERSA8'],
    materialGet: ['hP8M_QzoNjkRE537OIjpCIaYIrkXY3WQIZUxLLkIJnM', 'ihjXs_bxafk3mu01ohLjYTFpiQlachTrQ9EbHWNVP-Q', 'p2ciHOVm617uiZ-Wl1EN1Kho77vVG5NVYkF8NW9Ks4E']
  },
  wxd2442be3d8ebfd2a: {
    frendHelp: ['lbvcz-UCswFLd6MkdOMMBhVc6PGjRqH1DXr7q_PXW7w'],
    materialGet: ['ITU2DWbis74rlt34PLlzKiT6xtb-OHRW9lFNQAnJyh8', 'XBRdYykKUKRlqeJcz1FkR7AJsBfApaJ270wB1SP4PxI', '-o89XDlpQzpaIHlgiKina2iRLuGBIqS4UsSs72gF4ts']
  },
  wx3f3b45e23db9163a: {
    frendHelp: ['KATwXjuAQz_uKfLFpPpg-chVU7aSxYpU6LN4JCly8w', 'uERcynw1bIgqNB2zAsSIE8utTVMqzEPY2j3GL_Pajzc', 'JlzbeG6E6LomsMKkJ5T3oLaU01ZWH6ggKh1926TN3J8'],
    materialGet: ['g3V6oPL3S_nadYWQJDk0HDBkwFuyGqySQm0e0OJ4Twg', 'yImLEQ2iClJ6oztiRsCPZCnsowPW84PgwTZOQ7ERCUw', 'wdtic75f8mgYfb9xnrzzQaa1kVuRJlnk87LjkjMb78g']
  },
  wxc9d94e92d1f385b6: {
    frendHelp: ['I8Q-As4DgpYt1Wyc2pJY22IgQ-yb1wMkMHrbQerpDfo', 'lj4mTX0BBkO-0p61YsM-i2FycLasXA9udZ-PZlbjzvE', 'jv1jgry-Z7RkP68aKTfTXyGNHBLgThF-Yx75fLM1yD8'],
    materialGet: ['q95JvlT2Bw8e3TuQfRZVeXU2Of4dwAHrSEtDw3Itd-U', 'Rnq06d9CB84LkFRj6LxKJZWB4nO0-bw1Np0AFKGnxuk', 'h4cTgheV8zg1dfBlG2apQjko8M9olkJ6rFU1ML96tKs']
  },
  wx789d9d64611f65bb: {
    frendHelp: ['66dOA0IYyV9GN_4wGo5g1LkDa85UDX4OV02372rOfCQ', '3aww1yfLOkTih90xCepF-dMFpSjmH5g8Bz-XHwT_67U', 'fuSnslv8RcEoJ5lBrn-Q1Cg1mHMTu2jrt8KulQfKyMU'],
    materialGet: ['yOvr8uKjB6h0G4G2Ape11E6oFkgVMHssZr8tdMDF4o0', 'UB4pguiLyBgzKuIjSGRpuuEdBkLC3sdMcuY12Zfj7aY', 'bmM04Gq6W00NXdIh_P556qqklKcWpocpgi2ByZF1riU']
  },
  wx374af4e3fa68be00: {
    frendHelp: ['Ml_KP8A5Q8T9w9APZeD2Gh9PUm7VOfv4WVN5a8GaSyw', 'jx2hp4eI4LErXiTiI58_Nuyti2I8RjTACynpllJ3b5k', 'ZIe9zo_QO5fA9po0EwEQgQQUUlKyMrtgkeB-LZuoeqQ'],
    materialGet: ['We_huRgMCKhz__49bCWjhXVCWRDBYg3cSrdi6d89jq4', 'vCLTNHeYihU3H0-kglonO3kG40FCW8wQyiMP3JXFD-0', 'TkNrVRGeSH20_OHJG4wbg_Ix1rBN0YmErjhMK2kLI9M']
  },
  wx2c73e511c1040776: {
    frendHelp: ['LvqX-xFzcQrGzV1uG_d-E0OWKEIt-aeiq1qEhvDoHJY', '_efJhaWtp4DnZEqSm-yW1Ub2nYn_bP_M4GkBXOjieb8', 'VTFyv-R5Om-z8CY7izzFfABI9R1E6261-MCBhf8phKY'],
    materialGet: ['KsSElPu8sBY6zNGF0xKujYe1QhIuKMLx_Vt4rI5WopY', 'P0AFmcEz25UcgJnKLhyLchmeuf6Riy9mzEyfWkCC3Iw', 'P7cuW1Te9u-IWFPrTzrFMj-XPbSBZpG4x31twc16Nzo'],
    grouponStatus: ['nbLRFoXQNAEQI2jooxMpLzJhdTD7UckZ0cPNgA1N7uE', 'R7W4S0DLDlL7W05yJShskg4XCHWIaKJfYmKWMay1m1I', 'g0VFns0c-LDaHyzy-m2GJRewKY2qdMw8QqaLXWadToU']
  },
  wx03cce2407e6512ed: {
    frendHelp: ['VF574nRy3l2YuiWq5cQAfF7iRuG8-oiQ0STUPaT6V7k', 'Y93rPbV_Hdf46a89vFG7Jy7JcEvXIkf9JB2iUZQts1k', 'J2toTda_TkbGEf0In342_eZwbeWjvD71M9yR-qWkWPs'],
    materialGet: ['cL2X4Wx5mmffeIlZymfaY0EenelQiQN34vLWcULIiFw', 'xJgQURzH7rAklCjMuJspN0JQVWC3vMVKvmri6Zjf7pI', '5P518OL2voOg5Rd0xQcEhrv9Fz9-LC1GiGDYUtb4TIA']
  },
  wx725e614001062e23: {
    frendHelp: ['k5ZuF3mRlkUUF-P12IL53SWKyDQR-49jbjV1LJs6ggs', '81iaWrvLEoHllrRMUFquHK3LTFqxRa7FafhbrmX7a_Q', '9_z7Sy_WFSVD9lMx-P5Ob-a3jZlRlWRd3JgJ3G1DhJA'],
    materialGet: ['PL2hEeBLhi447QhvdX0qGmeNdtWxL5y7BGEBkZ8Xt8E', 'dgwR9ruWx6QhE4QsVm8dqleua1qnKBk6-ZYg3bV7Ubs', 'OOQgGhNswnDzuyms2Ezr9oftZdvLZ72pOQVClNyrHHg']
  },
  wx5993d4e794ddb903: {
    frendHelp: ['Z3aRyxI5WR5f8P-IqMKSd6MVC_KHJEF9Nag7Fsk1Dik', 'hWZvsMCql0YHb6XLxBA8AJ9vEQ4lL5eJkdcGcVDmnmw', '8Se42GBosDUdvQW_gGHuyvk4f_5sklb6-YCXRzN9LG0'],
    materialGet: ['V8lNbpqbNt-Y-dpGwiZBmq1niWvAijcuKXc9-yULWSA', 'B7YjhlXTLZ9Iv5HlaW4VDdrdqZgZBGxc1MxVdiOQACg', '_BkUay4o_0E_Inu48R4kGLonLTSYTBg5XzqfZfjc7K0']
  },
  wxa5a2d7b4453fbac4: {
    frendHelp: ['xrlbFaqW23M4mA9ecoxMdyuFF6WI1ycyidJYrVBiOlA', 'Gk57bZW9K0UAqvmIg6J_osswqe437PUA-uqk07Wuqkg', 'to2iq9b5gpwsSAgsK0rLVu2cHCO2z0LjDUBbblgmhlw'],
    materialGet: ['Y9b0xQZcQv7zhiO96TOENTKjHsiBVuhHwWLj5mR1pVc', 'UvTdd5PYp1DJy90OI0xXqsQzI7blTr2mbRA7dkdxevI', '85Yy6mP9R52S7bIQXues33_GfH-NBAQAT0RyoPBSzOE']
  },
  wxaa528f295e164065: {
    frendHelp: ['xnmynfNWMXovyIBVjbWgjOQ2fAZ7gqp37M-d1sOQv2M', 'N3wEcykjX3ovbsprS98jX6_-jl0nFI_eEMcoWaUh9z0', '9jwwB9yZwxerIhOnhaT_PaxU1ljaeZcoBc8jlqxr6sw'],
    materialGet: ['oXr16u8qy1Td1s2dJ0Lbs7Lil9B1zB6cYNhPPOlQVAk', 'pU8FgkzQFAIkWP3EfDSqNDgsTHIWsGzivPwKk7uo6Qk', 's1faqc_gQJtK7YpDQvGzr3ENDlOyKmxfbnVqn5fUqMI']
  },
  wx010439ead4874637: {
    frendHelp: ['AYMDxJCMXvsz6c8gEhMBhhENuB7e2HKPloiHPqtfLcg', 'rRTLUQUoolVRBxvOp7w61RkKQog_D2OJe-OIIcmzE9M', 'VSTCBZKREnfKdPgdcJHMeTnisHI0c0H7hzXFh0TTQJo'],
    materialGet: ['xXsb04x71OvLhn4wuzytCqXx5yFp8Vb7I1mT5QPXCZM', '2Kbg_hqORUj9vzCiKkyrgd9esKYzTkgNZS6sekXiidE', 'aDDs8q3AZkCFn-5_N3Uyz2aq6KO6HBFpNxp1dUqIo80']
  },
  wxae44a37b0d1d4412: {
    frendHelp: ['92g232CNXnFZIJOEK-pjQKN-7jtjftBvNHHDLFuZNTQ', '1S2UDyWmSwnAFdGEKe9PPZiCPn_7O6BE2dU8w9YIzbA', 'ie-SJoZl8Q97Z1ZFOxjIC796U8NnJgL6HPa69YWo6W4'],
    materialGet: ['iPh6EoLxUyEn0m0bZci_4VGg_tLZAa63rzILJFWSX5A', 'HlrUQsNiTeTCKgrh0eJ5tAEQtq8El2q0DrzKeUdabPQ', 'TiZF5IAbNFrXrSuPQQOhAN4HmD36w_IO2tBmUao9miQ']
  },
  wxfac534cae846bc34: {
    frendHelp: ['UR9Ro9UFoJr0WzMdMW6VG8SVG96Xj1w060vuTyoj9fQ', 'kZQoprjzvRC7RM6zrfFG7PICovhZr0cgZcRz6qA2Cxo', 'TRSGoTu-1XqB4JzApo4tLuYWJbIlvSTv3B-Y0ce2JfA'],
    materialGet: ['4QQSXeTRCKgbHnUfCP6zbnujsc0AvxWCfouf2uc0bKM', 'ARDNvLYwaT7o7SBal3dhUJ0tXj1UnMBjBPLrsRe56bI', 'S2fpB0fVwiz4U9Bx4RRhEP8iOqgCZYU12cU85hD9a9Q']
  },
  wx20e3d010ad274bce: {
    frendHelp: ['pcpr4dQ_1W2ZTdECLEKVEk0t9d9BCb3nbhKPYz6QBuI', 'A8pm2VTvXtRuuU57pZKx39joTdCjGpvVcZIdnRIF8q8', 'UWzf1_ENcYVCGcVNIwVrQaQlebzm-GvHwelIYToaZak'],
    materialGet: ['hdPH8E1n1MF3S3jOpfOlB7KHMCxqEi70pjFGlV3ykdU', 'ZTe16nDANEZlHR9jrHFU2tkuKbkvL6-qhltOrsppkwU', 't1D6v1juOXMLV4W1mGdSaPY14myNtgjbWqGmQLkqXck']
  },
  wx6a4fe470797dbb61: {
    frendHelp: ['IdddUW52f_ieZluf89HkOD7tfUpkhOXL_BtCavCFjvI', '74yybYp_ZNk4jj9N6oGLHEsvmC8wJIPIASGsiKWmHOc', 'sO1s8HAvxvpw-g3J3aFNRNr69zhxWOkdLKyKEbsYGqw'],
    materialGet: ['uuxBnwH3eRglqd3eC4W7T6zG3XZgIWaHCXBjwi1ihvE', 'mewqKb6RZco-2kpCg-edMmck-ixksAtKIIZSwEX1i_8', 'oAh1Ka4gt6c9Fnu5K4bmG5tJV8s1W8Mt_FDurOqhfLw']
  },
  wxe3015e79e6e4c9f7: {
    frendHelp: ['GonTIf8wDLIiltgS-bQZZdAWqtmVnE6e38kMZdB4Z2A', 'mrChs_1gvtXuEiLMEUgg96wV6Ad3SpN5yIvrd-OS5Wo', 'iyXZbuFLxH82aXk9KSl0xGvyjjcQLi3Qekovk6iPx4o'],
    materialGet: ['lnyGv02ndGGG_NEL9W4dnFtFkwPDmyGoCG0PqE97pKI', 'oSTRzYiiokvesmdYS4PwE2IIP2U9F1UO0qv0HiIJ_7A', 'uEpuigtVpwBq3Y-oreJzVaxcwqMUmGuWhYROUhUuz0w']
  },
  wx7ca882792045c343: {
    frendHelp: ['JaAiGYvp6i5YqAXbv6w30QKc8vvbVB7Hg0gSiHMQh1c', 'xRBBuwglF3otzCGoziZmz414iVrV7aMlWAguiPMQbkg', 'GlFAYKH7iMBcI0tYqZCSs1Lysi5-UcvTVJbdNkvxG1g'],
    materialGet: ['tijSTZDzAvkMyDCSj4TXdu0JOeYi0zxUQXqQkepCss8', 'jLZsNnNteuAQDPvFEQwJHCo9F29QwYZHwxDaltQpiMU', 'H7ToYH2fQDqpV5gOQaXc3sR0k88o_suP4_Ay3EjrkPw']
  },
  wxb946e1d442d0c2de: {
    frendHelp: ['mUC8sduxJWmZi43yYIGKgoxYh2xxdj9W8IztvYPMRNQ', 'RK1qcGOfQ3vfWKiEL6_9JjwI3LZwqq9UNaXvCjW6cXc', 'JUEqSYShDX6UMNeI0JI16KX45aQAVnDahm_teHxOm4w'],
    materialGet: ['72WW1J0lH1L06OlpL_hE59IoYaWCYA7fBT_tW2o-D7I', '7OGRhYiqxmRSy-k8EzbH1QfBDSrXWxOFyUf-reDzVYM', 'LuonTsXefLGbwfTjGNdw_YFWnLtBDU7ssYSSqVQRkVE']
  },
  wx2543471e3ae4412c: {
    frendHelp: ['eE9_jv-yN30DQYoiRBiEv9YTRb4mZ5E71Wvl0nZc5XI', 'Sbej0azHHtRyfmJ8sAAEJT79DCdEfFjewLZi6ul6zdI', 'xHiRwC-ahLsBGjbt1ON2PQrJXsLFyVj9CbeYUteKs5s'],
    materialGet: ['ujL7O1u03Bnasor7ZL0alEqxOQzh_QYa28bbUl9gI1c', 'vqJMpWb0HmzOe3yUpXDN2JubNl17HNT4zY_kE6M7NOY', 'N6kUGhrpUpt-vUA_LH61gCx6hZOyirqyUzZXSdCbGqU']
  },
  wx716a0a03cba95f66: {
    frendHelp: ['r69QscsBEfMRdKoaG2ZNSA2l-TBk8jYQE8KJySveIKk', '01ASppSTpQ39td0Q0oZJyQUnV9rEt5Du5Y6fwwvGrOw', 'Hs1UzzQOxMPrc6uNabYj8TyGwVFyWY242qT-aNa8nxA'],
    materialGet: ['brz8QnSdiuxCkggtKkufRLDih9uYWzaFA0F9pB28mQQ', 'Y7t_mLVeouKgVoD7Iqj_2dZVM_ExqP13cnkJ5CD8chE', 'RlSXrSND3Y356IW7AIixS3XwoCi7NU4Wlxm3CmPRilI']
  },
  wx5c2683e1f1d1ca48: {
    frendHelp: ['-wW5adhu2p9XKqn28aPfTLZmdolwxH2lSiHwdH2IqaU', 'JMwBA-lc632_Rlmn5zOtWSz8ZwdAkrkGl5CNQ4amSxw', 'qE48n6n61IcO9TGWIJynAZLs3lgaAwov7kqSyQFY8OE'],
    materialGet: ['NrHmI-hPREJta1Pxki7dWivZzmgY4sgO65Rl0Z7Nbew', 'hKd5aLRSKIjqIMLiPHNcxWf9DVfjuRmr4LdyzmY-q-0', 'JMxyirMq9QRktFg_FbSh5D7U3Ha0lg5gwyBq6GQYv94']
  },
  wx425b9fc66c8e9e43: {
    frendHelp: ['mUC8sduxJWmZi43yYIGKgoxYh2xxdj9W8IztvYPMRNQ', 'RK1qcGOfQ3vfWKiEL6_9JjwI3LZwqq9UNaXvCjW6cXc', 'JUEqSYShDX6UMNeI0JI16KX45aQAVnDahm_teHxOm4w'],
    materialGet: ['72WW1J0lH1L06OlpL_hE59IoYaWCYA7fBT_tW2o-D7I', '7OGRhYiqxmRSy-k8EzbH1QfBDSrXWxOFyUf-reDzVYM', 'LuonTsXefLGbwfTjGNdw_YFWnLtBDU7ssYSSqVQRkVE']
  },
  wxb11053571637a6a4: {
    frendHelp: ['P-PdwQb8m_59c-86597MS4hO22M7hxwJKk9VKV5HVXs', 'jAIenkblWGvtpkYNtjK_BdER8zhzx9WTzKZJay1Vd30', 'LUI_EhPTajQzQFZpk5rQQEcNmaV5YtCY2h_aFH-tjE8'],
    materialGet: ['9LqOt-l4tCsHns-FV_ObjoN4h6wV5EFRRvyuuAqLDlw', 'Zyw9kFjYPRMFXJPfx1t1TPWZtU52Ral6_tRcBX_O4mE', 'LuonTsXefLGbwfTjGNdw_YFWnLtBDU7ssYSSqVQRkVE']
  },
  wxd64d964d5dc63c4d: {
    frendHelp: ['nBWq6MkOqkRhY8M4K5MFt-oMqfjRrkHyfYSGH9hnR4I', 'Qkp6g0TEdk3S6Bkr75j1eykf3hCQsAlzhqK27aW62bI', '2hHA-xMCyl8fM9ygGENz6Gw1UDtIrIagPcAM9W_niY4'],
    materialGet: ['SD3jq4fEJ-Gp8YKb3nKHSnyiaugBK0TlfCxw_S7CKPg', 'KSA3icIeBio2EKBMPQAoOpwd8aDOK0LlrrFZrhWXb5k', 'WAdstdPkMzi_NBwPcDGNGCOQy8vrxmZCyxxT8bZ0Bqs']
  },
  wx7007e40af527fc78: {
    frendHelp: ['cznnXI5z2zgeKB0WWR5IVqDaE5WCSkrMazFNw2nklwY', 'CR12Pf_ZszLCvcVhTaw4Z-f-dlajrbqgnH8wPMMQW5o', 'oQTgQDmHhtTmVWd6tSHqGNehtI4IATyoM8EVOpcHQ24'],
    materialGet: ['AgUWZiMWJxruOfCMWnDMdNwdtIL5u0h_tpb18FYOy0Y', 'rUBBz4koLqeRKoiRr-I7XeHxlU42uZFVjjsOC5FZLHs', 'P2Rd8TVYPs7j-I70tA-IfgkBrbcb66wfdaw0wvigZls']
  },
  wx7bf6eab3a05bfd49: {
    frendHelp: ['o4YCUluwEk0CZ7Mw6D6jtxRY2RCCwNCagtieWieBu5M', '30ghB0LEiIQCemsI_Sc3Y3yuEw7lQAAHHtef7feaNwQ', 'FRYZ5k_e_7iXwVPkKSl80nxNV0m8VEFUQA82wYhLBi4'],
    materialGet: ['QBz07g8aA7Ky_fk7q8E7QXBbcy7MhzofCydPHX5wqwg', 'AUxkMS33azGyA2Df-RVlwmhU6OZNz5yIE1yYOa-J3-s', 'iVz_Zs3nkicuZTPxXbVV8_8SsoUKIVeLnY9e_Rlj4rM']
  },
  wxf9639e529e15f9e3: {
    frendHelp: ['yREykSnSPBhB7w-WQxh-ppXBd27tUZmN9wBvozhcYAw', '7DLSlO4rFVVfu4Z7dZ2aOF4a3FGmBNHdMxP7E3b_Rag', 'yRvuS1YfPsaKRZCmhCpTDJN5dsU5QPBGpUmFHHXw_j8'],
    materialGet: ['0JpEg27FOhecGP_yvomjOGzbi3_L7RS7Bn-aA9Hcd1A', 'igcEMqeMA8X6Zl-sxu70_cTrhWXD0gCmuj7m8xTDnRA', 'k5RntM75eQBnP7AsOPaIn_uH_8Dy-G0P3B4XqwZGKLQ']
  },
  wx2fdddc5b97780d5a: {
    frendHelp: ['u7VbmQnfpKCMmoYBD4LFc8uLiDQbgV8pDBzXTOFtfss', 'lQo_QZPANuYAElZ0Sm60Fx9lBYHbpyqh9G9nDnF18lc', 'SWWsFkVNJ1PDnaV4CSS6kkE392pDnHdzPPxee-n5mkk'],
    materialGet: ['jLncaD0B-kUqVUP0OSmS8DTZU1C3DwlQ05b2NxSlfKM', 'gQLlzB3vj7xG-npchStwO-hBwPs5AcSiiblcN-jH8A4', 'u434NM5rK14aT9JqqUgyUKIPJkOHBpSaCKUit6NDlsA']
  },
  wxf455ec8b55c44cdc: {
    frendHelp: ['8weExya3H7HACQ7z2WYpoN2Gav9vBTjrw6U-DWK3wfw', '5ZLPODJm1l0rdEJtF73rbcYVizt-fc6dDdBxcZGt8MM', 'zY_p_xXw_ZMzWSGuviJP1P_Qb3mJ7Satev_0UeNnV7w'],
    materialGet: ['UHnxvkkky4Tc2671X_SoxfASUn4qwlTxsrUepDeCtB4', 'Sl0K3tWfu6EBOSQEI9b_GfqyzOAbk2myiUuaR9DzrL0', 'TnD5VqkKdBkgnUlWgAURYWyjAD3PnQiR83Quv9pM0vM']
  },
  wxe9998abd066456a5: {
    frendHelp: ['4fkOsk1SIcWUh6B0NFDZtEBZ4O3kTvSDTG4U4Ha6O_g', 'rVABShhpXFrE-gxmb_koNJQbt6pSAwfBG_25Gzd9I7E', 'hKYRXgQxOJF5bCQsKB35BFx_t_4gWrNN5CO29PEx6D8'],
    materialGet: ['AXxwNtwZx5RRAtHcfV9uOF11nL4tu5MOu22ObcLOWUI', 'vFdhA28A296PdK9k2_PUCov-ccng795eGYXuDLPP4AA', 'qHT6FDljWt3YqoPbIK0K_urBVDh79dYALxO_BSOPLZY']
  },
  wx748b4321efe24e1e: {
    frendHelp: ['ThB49RqGrFh6fBh3krYe7a5TEWeUTNzA9Z2uyEo-CGw', 'oTSO6vIrLVM60nE14rUnKoBeqiFHur3hVd8D0ict5v4', 'ZXsvHbSPXRa-9p2jOP_uXQXoAt8UArwxkeod-LZoxzI'],
    materialGet: ['nw97AV9k4T75aYojph4aBojCOHh1ClaJLE8wVJK6X5E', 'AXSoZwgeHWk723J8z8RPY3G1HA1X6IIMGAKQ0ylDAUg', 'eWoUXD-hQKhymrVNjGJ1qZJvz9BOsSVmXHsECrd_bGI']
  },
  wxff8ad18412a927e6: {
    frendHelp: ['NyapsylcnPvzSB5z2SQyt6Y6b5EROLyCTWvYEz7-Tzg', 'lXWEO58WQhmP5ocy8w3bV70LLcet2FAXLcgBII3W5P0', '1hd58Up-5Q7Il6kcUyg38b4YpNggzctvgc_hBP07R1Y'],
    materialGet: ['G0_HD8VuOaq2WyKhodf0OAjWMDbMBToMCNRahFrwNNQ', 'gcwcmI15Pw-HHbaRLD7aY73aOEkL4Md1JTH2ipHYfbo', 'goQFfNXfO3sPXH22RWGdSSTc2Cmbd9cnjQSQUpKUyio']
  },
  wxa440ce8e09cd209e: {
    frendHelp: ['qPhq9soobYBk7_FzWvkjz42pO7CDUsdFFrEtrDPHQPc', 'E07W4KRemCjRKVzB7yDMGfEaQOkzPyUuNNaWt5CD718', '1qMCyVc4Tk9mmpHoILl5ObBEEVox1RHiPnEpc8afChE'],
    materialGet: ['fsdbrwZMre_UkuqoU6_gDLng9sImw8zFhoX992HlkM4', 'sKpiHv8uVb_F2LiEoEEuzbidCeYX2R04JhA0oixKhY8', 'fr_lY0ao37M42KD2zncZBGvs1df6b5lIPtGuBh2nEJk']
  },
  wx366051bf1dddad24: {
    frendHelp: ['EEt0I9TrNpjXIPajoz3yDZbea1u-AdQL5ufgdcbYkUA', '_OhvokBNsq9RNZW4FqoWVDaE7IJp-y27c2dquQJF5ss', 'VJwoy66eBuw5fyQJbn9XsE1ZGpi15boZeAM07ZHZTmk'],
    materialGet: ['YrWfXyAcoEiVSZyspcdGd_KP4_u1WmrYFeBna_LFnOo', 'kWvVPM1ZxLbrM4mfnZJUa3pV9hPEc2gVVDxfxl8gL3E', 'sjoV1SAHE3Cvwbm0zTnbgOqqw64OD_lDyFddqZyB0jU']
  },
  wxf4498d02f06e9324: {
    frendHelp: ['EBogWAXXa86oWybbkkRfMucMBcHb4FHmydUgJdDuUUg', 'zOj0BgKs2BpbfNpa_PT6v48qTw5LxCyyWfBf0rCFxEU', 'yG9NLVk41T9Yu5hGbtl7faNmJQjK1cgR8e_KemxLSDI'],
    materialGet: ['1AK_B14MSat9ySA3u5Jf1Wo3xYC-jVvxj8y4bSFlhrk', 'RPb2lXmRlYUgQNLtIshp6Ja5SMCt34ZzyOAImKw6PM0', 'FNv6qsHwzpkNAgRX7BEMz70zsqOo5HSPy-qlFLpeE_k']
  },
  wx271801086732bf94: {
    frendHelp: ['EsPRzq-lPuSNXD_gu8XriZOFiEv5y3E-MaOZnTfQkUM', 'oj5HP6wiGpM1BEgcKzXphnVctuzCSyabMScvsrDBRBs', 'dcnALLHK3ufQ6gPMpAirTc6_eAJ7oWJpWXgB6nI7syM'],
    materialGet: ['hZskeczAkhzTSUf1aHnwRpj-NcTYEzVI4w5bJkPDeek', '9tbqigBUkMpPHP4sefj6S1PSAtn6VamTWNYdup_Sgo8', 'fwCeb7n0Y6xpxjYrLNpfJrEXRBoEGlbUFhZMYjFWVD4']
  },
  wx842fbcfa7116a0e4: {
    frendHelp: ['B9GVo7yK534fMIo8iybQuMIt3j0qRpmP0aYdri75kKM', 'Ywe7kJmJ_S87W0VQNcw4e9_QvHvB4lR-UftLJW1z-Mw', 'kwBS6zmBb3J1j0kxGqtZzukhQ3tQDT8KPFCQxi8by-Y'],
    materialGet: ['neF-qzmRoagickrF1R533gGnLjOfxY_ShAkChDWQqa4', '53uCJGn3lY9NoIv01ZoRU8bzI_b4PuGcxln0DT49ADI', 'NUX83GvOrXI5s8uS8oFcympp0GA7GVt-0kF23xQkm8k'],
    grouponStatus: ['oz14vjRAw4hKY3rLl5U3G51081zHIYzkKaHV3rvPrwQ', 'CNSwSWjzyqEko8CI3T8gLJq6ozQCWVniamr4VXvRUug', 'VArL_yGQF0dlrSZ1av-jFyVbHYafS8L1kGQ7iU_9M6s']
  },
  wx9793a1259d1f5035: {
    friendsHelpAssistance: ['zueQCWK-v7Sg9MIccqvfLpbBaWCRGIHQ83Vnss9PxKo', '5xzONnD2c_EEfpWHQRuA52Z7FoBH1qQTaakx9EgpeR8', 'zRSwIrzCuoBMGrFG8BEpoGYva3sA_HZBYNZiqan6xag'],
    frendHelp: ['zueQCWK-v7Sg9MIccqvfLpbBaWCRGIHQ83Vnss9PxKo', 'Ocx_-Bz-YMK08pdNGL9rbe_WY1Ga73a9j3Uhp94JQbw', '5xzONnD2c_EEfpWHQRuA52Z7FoBH1qQTaakx9EgpeR8'],
    materialGet: ['zRSwIrzCuoBMGrFG8BEpoA5DyUtUSj934ibnNfxfIB0', 'Yrjr4_871TrRU3MzZ83_dATjgw572VhWPv9Ycm9xeSw', '4QOmLHcxASciMXv-uK_OUvUSSfLJ25csL42ND_vy4OA'],
    longTerm: ['TOxrmI-gwqK27BvnCc8oIWa6z7KQhur_hl7ECPi3vB8']
  },
  wx4a590879eb5fbea8: {
    frendHelp: ['vAekoMW5GNDnYcIlaH9y2QBDsdou5XM2fqCVJd7WsP0', 'wIe7x5z-2PFHnRlZC5wz8e4fZQPSIwSuQ-3WLISnePo', '6kKZUaQU2KEa1Hwop6kCFZN_egEVb24bQJiX3xRU3MQ'],
    materialGet: ['Bb7RYyrzOtoEFwbutnTT4_zBaWU0AT6OzLMojysuinc', '8DSu4UaYXOydHRGM6YjlwMy8GH5L1YlTg1oSG7uFLME', 'lXDOrMrQ1T87l9LZKy2xvbQQgBYOsW22N0HtHPhFweA']
  },
  wx75d947bbbc94924f: {
    frendHelp: ['OYTLURTejehpnJiYPvuyCU9v6IqH3QrMb3__VPdUbL0', 'RswDsN7fLX44Vu6T19EcktzEGYdDFl1qnaBCjGY3KzQ', 'TSbvip_2KPuRXQAUOj9-I7T-mNfqNd7LzoLQUIIVOE8'],
    materialGet: ['EGT5Y337FKTVzUXDFnsyUn7c7GAtsLI8QczRuKpsChk', 'f5ES8E9wU73yFn2MXY9lm_JXnGAFHYITBxxAK-tCtRQ', 'JLPLXh2jG41xWwGivyXHr-bIeF6ZIiPCndGIF9u1jZ8']
  },
  wx7676d5e0cf4a1309: {
    frendHelp: ['K9rB2NYehn4VXmcuVPhU3Ob8QmrIH3ZIhFTLwwFB0wY', 'ANjxJhfJLyeIQulgdIOeRWd0fHxC5pFFYrDFwbwcZUY', 'yVtVnFVEMgVp8ee9WaULo4BpG_mE-KE-6R2aAfJN0a8'],
    materialGet: ['ge0XgPMSKP0SrgtBr1sM-F0LX-jjvc4adFw6THYyklU', '0E6wjhrKREuYd2vxFBMgNopoIdHOStlbRMI2JHvkY84', '7Q3y0j-z2-_oFbIxp_fnWyTCyL3Uyk3b7OZ3gac2IZg']
  },
  wx39a658db2cf7bcd3: {
    frendHelp: ['HB3UCRqn6Ar6xEWwCGcyg7APqjchZa6R7VqKKXaBSNQ', 'bgWwVLtlaRlhs87bg778EM0DBPYz1yP6rwoVhkSXN6k', 'EZ95R9nOgM64K15SjGeNdTqSY-hMATsEUTs31SyHzCI'],
    materialGet: ['COSwCk11rqdV2vyRWsTH0CpGKTYhBymqddsWDp1fEVs', 'JhoelEjNpoU5rcBs2lD3I4QQviQqMW8fxRZ8fB6Excc', 'DZvEKfDFRaEMzLzniH2YYBwS7r5jyt_Sj_VceBR-o3E']
  },
  wxc48ca46fa56d01c1: {
    frendHelp: ['i7Fsc2ykTHuKpW0fBmmX2JH5oCiY9ZDJUQ4S4TTy-Z8', '9rEY95N0puB63OwoQMvskaM1_98fqd82vglhEd5dT9g', '8Xtx_e5xbE44vNQamb0-gENgK3JZ3HWVJYuaprcN358'],
    materialGet: ['uPvVDyXm2rVwVlVZB28Kck9hjW8xzLdp33Esu-u-NqM', 'ivKXNBgxbK6jg0v8Byzb4VP0lDs9rEAhReSAM8T350s', 'PMakFlIrfxl8zebEWMjSxmw4pPYFEopDHxRjbYBRNGg']
  },
  wx362021a70979b961: {
    frendHelp: ['_2ijJ49FF5hIkgqLIndFOVbZiSirorsY17IguCLpMU8', 'XZUt8Rg7KwkijHwrny7A6gmbcE2YtPK2tlyKDwiVjqk', 'BzNVG9WkVsiEsVOlno-gg-4gNZ8YtPAHdzWho0L7uxI'],
    materialGet: ['rMpjBqPb4aBhgWYzKPhgMj_B9bYi6vEAEHjexFRDx4I', 'GRVSKEzoJSf0zfBPNrZxi7n4WvoCO6t7zw2cvIwIvQ0', 'Mt3b1Ulbv7fzYSEuCQr2Z5N1MGqMenUe3CN17-Os1YQ']
  },
  wx7b245fd45872f65b: {
    frendHelp: ['HoFPnCW_n_w9jnIsuy3zHVBRbD-xpI-MxTk_JvRorAE', 'ljiFbnXXzfuTvVKTkpYnLdtSOZGybU9WuzkHXKzflWo', 'nLtk1b93SrDmXSCwtMjSaPDIUqTJxMpm0DVEcJWPdG4'],
    materialGet: ['LQfexeM_2QdtM0ZQetM2U4Wgq32F8pO08fUUqK0RL_A', '23-LZnKjnv7CsZIKCIKvf8hHitvvaIIw0p7rHIqActY', '3eRsWvHJHYnPHIjJxG1B-0WjtIWkBz6IbJmOGuiPpDI']
  },
  wx0927c4aec4dd3b87: {
    frendHelp: ['sJhXeA7xXz3dvz8Ghb2iawZ-2Nn71kkdZRwTkRlu8q0', 'sm7VNx278cKYjpHo-mzZ32hoe61L-jJ3iGrU_zWdHrg', '0XGU1gaOTL_Zl7O6HRaA3rCslWb-VWglJIluhmUYRIk'],
    materialGet: ['iQbIWkC82W3nlMSZQeTZpAqAOvVB9ZYDvgrw4hxv68M', 'B0UDW13WzqN2uIeYqgUqdVO5C3M71K46UF2wA-_mAJg', 'HwjyA3_Zrs3AsNxjsyBOmU4XagHAHFGeI7X2u5wMqOE']
  },
  wx152534023b067352: {
    frendHelp: ['mZThR4veNp3Nm82ulDn70Ac496b15F9a4--1e74Cvz4', 'rIdq8JrKBjIRYLpMUM5cotvoBg4UK7x29rX-Nf-YPnU', 'jouHXom5v0H1KmuB-ART6iM4b3JbmfBcHe3DMV6L_wc'],
    materialGet: ['OHr5LvtLG4De1dfqF5pzAUXeoZfyOtYksldEsHgB8Pg', 'Dh4szN9Qoy9TkjbBU0qzRoY5zMmXdndJeknaX54wzB4', 'qwE0pA6mWlK6gjVik_W49hIk8M7TNpmX0x4j2I457II']
  },
  wx9bd493bc03cd79e2: {
    friendsHelpAssistance: ['2DY7lDlhiMKTY9AUmchg5AKMdjqedoD1E137mrtM6GE', 'x3cBAuOSg91YqljmPx7VCJgExg0NFNmh1YXt5_EU9BE', 'Z-dJONVjhE_NxWvWkEk63y8Lw5n52ydfB7yHTwSddwY'],
    frendHelp: ['2DY7lDlhiMKTY9AUmchg5DP_C4ZfQPVHKCj3H--lJbQ', 'Z-dJONVjhE_NxWvWkEk63y8Lw5n52ydfB7yHTwSddwY'],
    materialGet: ['Z-dJONVjhE_NxWvWkEk63wJ4_hTfPknc9X-xB2K96a0', 'DUmQuUuBCRYintR8PeF_hHBaCz0_FCINgXbBnZLE4gw', 'H8W_e3w9z_ZVEc47kFrmLnJrX3CDuZmkPayYucC74e4']
  },
  wx1447ddcd1d533642: {
    frendHelp: ['_pP3j8OiyeFRQt1aNibhz8D4PK1ssXK-EmNcQTbhVHQ', '7qb6eiSR5gWjQAtBMmwztzgHDej-0vGo4L531jMvOnA', 'uLiLBYcJzDn_GWg_q5HimZlm85H7RvlGQ4QmQYY3ZRw'],
    materialGet: ['5UOd_-c6Sk30VIqg08mq_Eq54hLrGs_CDEY-fuuKolM', '5ZRt_XyQOasWywAiMX6iCYTneGk0Kh94n1kJUq9ujn0', 'fwVVQvmDELGoGRPFS8DikoqjjuO6d6dzquoJGhlIuBg']
  },
  wxf95569c80fce3e2d: {
    frendHelp: ['dWhKC0zSustQ9plMbmyyh4yINC2gyWN9aMYuFYueDzk', 'rW7WAbEhGjCA4gjf1EmEJP-sRie6J4j8aEuIE1cF3K4', '7oUPvd3Rvu7nbwByVJrp-n4P2_VXJYPdjddTcT8QLPY'],
    materialGet: ['tewsUqZs89n3evP2hZngfZxWvlGetuHX45-p6WFwu-Q', 'khABqGJbLeLgt07f0s2XQRSJeYayZELAsZn5N3kCQ8A', 'mdV2gu3S2wC0UM7GesQQUUwqazVVuH4mpCkef9kZ_Nc']
  },
  wxc5ab4fd2de82e7de: {
    frendHelp: ['keq13BMSgwU5Sev2clPIcF1Jd7nTUm2xpSEBDa2FKCk', 'Fce2gwdFdeb-bKXHyixm56zONfcmbzm9xSHmIxxVhfc', '7Lcddcb4ICf2LPuVbsX3I0XK9eUvYaC7oaVxNzM56fk'],
    materialGet: ['ubBGEolGjDyHFvUnzhXySfGkTUGhvWCRI4ms54n9Ic8', '499zNBPLa-1V1N6G7Mb5GPiTvUM0OSgrtNrQRne_9jA', '4I8wYbXBNkIqUZ4XIqGSy6nnkb_ox-bBWGcUK_PygMc']
  },
  wx2c8afef243748114: {
    frendHelp: ['loKfMKyagF4mrY4gDsN3Szt14Rj0ofI48ACEsINlhSY', 'k-URcD4hQaNcttpElXzh63IS6-MEMvAYwtd1EuJvOxc', 'BUtXJnFin7d3XcFsxETCNGnYaVpjhbB28EDIKKBtUVg'],
    materialGet: ['-u8yZHTi44WrEbkUv68ZVUCx8t6zhMwZs180CXMJUvQ', '3tgr7oa7tgQGKH0lTcitSsaDAkwN9dSdwp2pWidmVno', 'eZPfIwUGIIbJOwPw8ltjXjRchNKhiRTU4EjxFSjokR0']
  },
  wx31977fe24a5d95b0: {
    frendHelp: ['JPIYJAti9psoFOT-iv_LbAvR2pTfzqFacy7Lc7OXkIg', 'IE86Vv-IA-qLQ6fy46UL_bTySR-AmxQ2JYcDPKE1LRU', 'rGz5xLh5MhWzI7gV72Mj6Q9LaLH7xazP_hbZI2d8wKE'],
    materialGet: ['LTfhKI-7w7CJnpaORlR_-3H5i0a9AzuDBJn9ts3LeAA', 'sxvZIlB2B9qUrw0awuTQ1FT8pMqzDT43QRAQv8ZhkJQ', 'ElC7gVtJtZrlwbzh-Abq6UAPvhzkTgTPpbIgOfS8bpg']
  },
  wx7e0a0dec5b9edb71: {
    frendHelp: ['lrlmRKrRWBhlGK4FscuKc2612SKRqbWbyXm33kfFjnw', 'Y4JBsmLuWrE3HEeHADU64Y08gEzOWYZGltiTuCGeDiY', 'uoX-6jOk0FkIRYrYaux9Fs-k5JRh_dF_PzBQW0e_U6E'],
    materialGet: ['SL2aJwXtmUSoz3uiWNccLypI_IUhJWCm1L3PW9vmEWU', 'QIapVeLPK5vUeBqgE3gGutdiy11cYgAoU2ak4HsdZJA', 'CeXEidL-O_O9BJx7lxO7PD2-CIQ2WnJ3qwpjpD-SThM']
  },
  wxeca63ec6abb675e7: {
    frendHelp: ['NikaXxeq8XYj1HaggataWkGRdcVH2o-UcXF2X8RsyMQ', 'r_JdJpQxUG-HVOc8sfwMqanyX4NCI6PdfEua5LO78tI', 'kO6MkjTFWFf1yXSR24gRT_LAA6jdASgmMEopvYrTZa8'],
    materialGet: ['1oWDn3at9fKxD-CRSgvPUgdI9XdURp6_Ak5OnGLALgw', 'Z3sXOLCMDM_brqyaHPg5mX1lobl5OXiFpHsnqbNP3HA', '0anWeZkTZC-kh9hK5EW8tfwlMxKz_FOchxoqifKheds']
  },
  wx63dcfee2a5756e2f: {
    frendHelp: ['nT-ffrDfRav0IHp0RoQ81uWnA44S8PsREBbOi092rMU', 'zReSvPbyhaKT_F0rQq9YpArjaYtsAB9a4yKi93V70mw', 'bJJ1BiZDugMgvZpaGRm_BYDnWcFdbS_8wJofC4g4BP8'],
    materialGet: ['nZ2tGwOXzM9KsdWEI6oO9uFAWTiOcZ3JDyfw6cYT364', 'QveE8Ws3i_W_w3dqJKCgwzKtF2SzFLyZDv8IlAnSygQ', 'smxxJuHto0LngJBDNDbZrvGot0nPJlomi5HLZIzOCwI']
  },
  wx27f238050e213355: {
    frendHelp: ['gQojQUT8VdOoDQtOcFFkux-gxTLjF9lW3QDf7-MNUZg', 'nGMWr7YFDtWMUOyQNv84lVYUZ4Y_a9h1wam_dzxCzR4', 'ak62b0hKbAOxDKp3eWnTEM3RBLfASnChnyR57SjFOCY'],
    materialGet: ['ICP8ITpIfdbieTgtZjQveZ89EwZU5yYCbfdwZyPBYWM', 'Dtg_A4ascEJci0EuKHsWNpcw627NrmPkKFlHWdEPyq0', '7KhpmJIA2wGL6efxSz6tZWKs1Wka58kZQKcBlpYUOCA']
  },
  wx02b31dbfa1e30da7: {
    frendHelp: ['tEnmX3rADHLshTKzj_xv3ZDM_rQ2_L2BgZ71BO6tS2g', 'FX-A7IhI4BjETtEk4OjExMgPZ3Xl5gE0qs2ThSnVqro', 'XlB3qAeSCPJWHYIh6DR7HzWxr6MlgS104TgnYpKdfOI'],
    materialGet: ['rytLA6aV5v22tSeqGajTFk01t1F4oLjiThMbIjh2QKg', 'LrrivKtphfV2oteCgb81roYfbzyds8WjuAKzHpjAIjk', 'WFOb4KK0MDLJje02hGMsuhobgIfj0CDRWc-GM-c134A']
  },
  wxc1828992ed730298: {
    frendHelp: ['wwe-WigAEU_FA5CPicCnS_yyQDfcD8Y3BvJ4S-wihXE', 'c-4MJKdvkLMr5EVzmjI5brf7468BHmgwZXhe8Z8m27I', 'QCiCGCItGHz_NML8J0KtB-CY8_ynDvJvaS17_C6TBTI'],
    materialGet: ['djabMq_o_l3EkaD9VNvsiByFoY7riDy8Qu8CmicdBo8', 'Ed3SgBDljlf-AuPPkjH1wZI4xaInICzcD6V3Piy3sbQ', '9Xoq5oT-1EMZ46_YggPu8GPCBhBkcPXOK8pL_Pvu2B0']
  },
  wxf8653027851cc642: {
    frendHelp: ['u8FFfrX8RsERV4ysABUWpvdnjtd9EzA8s6D36bb0EAs', 'Wb62P5OtRgeTmfD65oqT2AhCvYCVZtjPzcNDB55xArQ', 'WFWkk4No8kG1qtfIEzpL5vOtNO_5liGr9SEbNsCKuLQ'],
    materialGet: ['xbYN9FY43pM7AWIJyJxKsqK9Go88IeQQjzFAbd1vl2A', 'WkwsCWjn9ZvFNZ3f30SN2Ikdh-dJHU_AEAZ4y9W6s1o', 'aPPRat1fYwdjwnDw9P4KjLbW3xlyoGIdcFenCExZ4M8']
  },
  wx7054458059f1a8e5: {
    frendHelp: ['UkMIqRt5XcJG-uTdaXBfvYWMZANaeFfxTAO0hHmfn5o', 'pNP49n9IDER8gdCph1oVUg7tIw-DnCmsnf11QQnQJx4', 'gIPkBr2u5e4YRF9_Ot13QehfQLFdnHesCjgdm5gmGJA'],
    materialGet: ['-1MhCXmew0LAIYlW7LWwlI_KXeyp3btIsraVscyVcsE', 'W0EHCGK3w_KEDAkxKTdbNTP8ZyCVy2CUPAfcjwfkEDs', 'QxMV7ZFocOPYCOY0b8mMkaM6l4psVme8gkoYeO3_IqE']
  },
  wx544381f62456653a: {
    frendHelp: ['s86V-JM7K4AaFVHoGrSzZwclIv9mxTs5o-RzTCt1R_Y', 'PgAs2dn9j8BujcTbC4p0V_EoL7QQqsovrsuNWN5uuqA', 'ER-62ZQ8Z4tOZOT9jPyiJYLUzLPTrcL5rGvAKK4YgHQ'],
    materialGet: ['wyzTztvRx51kvI11ov0U_G9MDEoWMtVmAfs8rzLOkEk', '8-uiEquw1wt92_uOLf6dJMJKwxJc5mvGy82Dpm02EwA', '_djJbn-5Y9zPgJgbhZrTl1-IMAZJD4e-k7vhTxkyvj8']
  },
  wx7c76ebbbe90e9d0a: {
    frendHelp: ['R7dXBux8v19e3E5r25wlxoc0tQHfpWaIN6XTJmlSFQc', '9-NkxEgmJttZ1R-XU0kaFKUt4Z0uZyWDdlfi-5_R4c0', 'dw716NqSNpVZvNVTPMSjUX-hqTPzTxEp7wPQjWjfFHs'],
    materialGet: ['l6CUWcAW73wxf3NPai0yZ40t_qxsLORSxzkLtl5gU3A', '5mi_O5jKZQZR9F4YN20T6iT0KuPgykNKZIyGR5t4MiU', 'mGNJSx_Lc3dTPAMi4qZZ8eXSUQVr8exqoqtAYajZhyA']
  },
  wx2c04f56d8943a348: {
    frendHelp: ['HWprF9DLARYUf3Xa9IqvSlGHD8Ql5D5nhalSbCHBSVQ', 'ji-xd6-oRAQAKH1IYnJmI6r-hCroMf_iVtq7NWeY37M', 'Uj3DLTBS5pPevAfrw6qBTG9laQzvPhOtxClaPjRa4ks'],
    materialGet: ['8F3Jla-R9ec_BcO4X5hGgjwakdLMibI734WDfFEng7M', 'PjAtVI5RCdukB4VglkdwRZ8N0oR0rMTRDIbU6XWpd_M', 'BNumMM61g3SlHbll7oY2N4oGLhxknKjhnJiXWDqiY3M']
  },
  wxafbd2e73bb5c13f1: {
    frendHelp: ['vzX6XPsYzQPimWry-1nD08XkzUoK2NbHGI5yNnMKKI8', 'R2PUKi13YpOwe2qtaaFCdzJ3m9fAs_UHmHBSqkoQvGo', 'OTxYeFK8OmYQmVU5tYrLI8fz-ulGWEj0LC1z399UI9c'],
    materialGet: ['AKNxHn-_5I8A3snGs23QsXpefiw07K4gpTOmYgghnTM', 'FryUZXFDvsH8INr0d0lqh-rg5Dr_stDvG7Ml6TfRiUY', 'YKkwpJGvUevjKQOk6dv8DggxQnv6iscQV06DgJTOeVI']
  },
  wx857c2e39de528c44: {
    frendHelp: ['ue-kMEVLB5L1-0bgsiDbARUVQs6E7sa4C6uNvvwKD4M', '4e_gfSV77i5rhBY--m942lFqKN0HKn4-28aNd6_Q3ss', '9YSEUsJMmF9q7GAHIWt6iT6x3PIk--Eu2VlEZl3UzJk'],
    materialGet: ['5dfLAwAwEM8h9igfqMtuSedXldOZAd-twEbF4M_IiOQ', 'w6hXwCMi3-KVRuPFIpd7751V0LanmQSwd6Li5PiDsO8', 'D6Vh7Egf7fLflHr7r7B6gwSmwAb6YDpg415LBlql4bc']
  },
  wx3ce3915a179624b3: {
    frendHelp: ['zqle63LuKYhZv63CJpQwv9guipaY1wgYo6pCJUY8hWo', 'ec8BLeBC0SgCpR831SOZ1RbWRJTgYKG_CMj3sPL-ixc', 'lkav153uhdnewMrYW_1lNYCmWNBtdxe5thtdyX4o3PM'],
    materialGet: ['s4PG2DWesqUqyfiPGLBWX3FOXTNLpvNojtHqN0fUjuw', 'pquWoNqhNdcA9-tPezV0gZITyyHoqa4SRv1-CI4Pfj8', 'vShh_oVEYgBhtFPtReev9Nd0HAHvdXnvhYpa5Z0FNwE']
  },
  wxd9b2c7565dd91302: {
    frendHelp: ['NaeTBp13ne9znq94wVYKafvLi2g8xe0TxqG7OEJpAYI', 'vT4duQn5xcLcwdljhXmrK-wTZIJ5fU5PQYeQdVK0Y1k', 'SLwFv7eIRh4WUD2z4Y4yQfleMpovx5ff_p3NNo-MJxs'],
    materialGet: ['H4ZHxzgeXtBcQ-iAW5_mwatsboiqWxB9OS1YR8yDF-Y', '3XA2Bcb4oyuErDPd6qUFNhB68h-viUPkwmxwmW-VtP4', '2yviaC_6sGCYZZXGohg-1W7ea96S0wWnPqAxH8T490U']
  },
  wx3fc9749fa761bd88: {
    frendHelp: ['EB3h8E1zmFI49azkjwULtxvDx8DvUgT89xVOEnx51FQ', 'ATXZBS1sE3HEQoQ7SOgNOacrRq6IJUdHKIeZVwif_UU', 'tqK8LF2OaCwdu-HEjQ_1SPcliWmrrA54qBkim6p55uw'],
    materialGet: ['6zrczRAP5k7VWGr8tj7P7n13bPJu2nynrLc_edEgDgQ', 'E2LupjMFlSMG6p1bpKu75o4mXiW8D-PPaou3zKLaCvo', '-u11RWZoDmzkMm2TVDLE7T-9xYhdSdx9NxbTpKKpXVQ']
  },
  wxa3aa4406e67d1206: {
    frendHelp: ['ZCKx1W5yPfes3lDympJ5LyXzToZCaCfkt0OS53s-GgY', 'pm2jTnkBYuHyDLxFlzVvSpHCcp6iOCaIp11jxdy8a_8', 'DIj7c8-JxJSbhnPqJZ7uWftVyqRiUAVwG3n4GCTlVpg'],
    materialGet: ['q7tpPFx7kxd1A_zDpyJgbGLbhVa08AulP3vYKX5TACM', 'y-6fa6kB5G94YO7zecyWLmOTPgUo-LCj5sCjs2XeOyA', 'W7BcK5ooXAhPyYT5ZufleRfVMaZur0fyB6vojMhjfR4']
  },
  wx7b4caf1894ed179b: {
    frendHelp: ['iWo8vUF3AH4Bhz_HY6WDUk3GqAJZum5Pou8KprrpAvQ', '6BBcdzcoqoOzlitUNq3-h5cMoqel3x2JoxvbO2h29fY', 'X_VVDV8BG1d7XqojFHFwsc3osKZEa6x10C0o-DC8--8'],
    materialGet: ['IQs8S39ZH8rFGFlSndbJvwdlUdsFbvUzZ9o8ph14PI0', '16EQouB3H96dhbnioOEbaeIyxP2SMhWtoRMbXMNMOpY', 'bH2bGas7w47EJDF7iMVzC7gOIP5dB8RLtV5Y69lvQOQ']
  },
  wx4325e25137bec755: {
    frendHelp: ['YrN-A4gxCY0yAF2csw6OKBkEfDCIeDgpNl-M9ZxUURs', 'au4XvvARlCp4QA2uBIPyuu2ezyBlv7H7wmkmPhrBJbA', 'S18ndjTcoEANUcgW5fpgL0_BjB8ei0MrxiKILTEjPr8'],
    materialGet: ['iyFcVq0mBOng5gkThXvPp6ky5KdZlbnuo_lFB8jih2s', 'oldYcdNMSS1NTvu0_D_Vv6fX-Ao6-5-p4CF2jk787dA', 'HztHX7cAloool6jV9mRGZG_wnKaN5ObmqLdsEQbkDMI']
  },
  wx53ac611f3cd562f2: {
    frendHelp: ['j5RpzksO4U92-ZXlCx6HSHbSL-PtFCA4vKBsXN7_XZE', 'dOebFGJ8_KGYFzOs0oKOo7sFtxG2t-n1Vi4Z_JOMVZU', 'M8ZpJ-vEoiXkQFDEzcpZbzcWMttEpRv0DdvlAv5C0D8'],
    materialGet: ['VgfUWQv4rsQ0V48PlEbJvKoek9B89MYB6Nu1jYyq7cQ', '-mpyFM1avUksY8urn4gpqYJXOjF-zTgtUsOm47EbC2I', 'WYDsDJjkDdTgvXvTZTgnQhCLFTC8CUVPQEdOVVz62mE']
  },
  wx4449fc9af831462e: {
    frendHelp: ['yc56IFb2D505wJJ4PfPERPG3WYplCMM06teE5RwpB2s', 'fhL2OoCsldrqijIhpJpiDZ4iE9w5NGBZuxUOS6llR1U', 'pY7j0uDrSHz0Fnwy_cCfRY_BVvWNElCOjL_z2QHwmbY'],
    materialGet: ['_AME9tUrAM68IRSzoP-PI3v_2wKC3krX_bWXSRly_5g', 'alZXr9F7e4SPCKRQrfWNRGA8NwRgkxzFNuCUyR-6EEw', 'kvgsi47W3MtrPefK5oykyAwrxpxcbmLa9BU_O6V-Qnw']
  },
  wx665712de6492f7ed: {
    frendHelp: ['9N79NQYRoIzEpYL9eADBbQib8EpWEeTeX1iQl3CFBPE', '82osko9tnm27qkmLA79rodsbVk5MsvH9TQn6FzGLHtk', 'O_NNdfzvXfpYjcBCPVAxDTMzgnrETx8cVfktbnsJIZI'],
    materialGet: ['nzZKAwRkrdexPdo6hJntUquwTBOEPbbLEYWCKivIzfc', 'fwALX_payViH4M523GFY5B5UlBoU4LR1IMOm32I0WEM', 'UqKQweA4Wf__b9UyZ9zbVc42TaxptXh-Qk3PoRbeEq4']
  },
  wx35ff76671a47b6a9: {
    frendHelp: ['X926eOV2X5q5KwTD1FFE3xiXAKkZ2iF9_9x08caQnT8', 'dYbz2QaD6CAvYLdkmbna2iPbZyCRNYAaiO684_og89Y', 'kH9Vqsmjm34UExiKMS72l5T9uxKt8qcSiGw1BHvJjOY'],
    materialGet: ['lPNhbNP2mdZwsZ-s2zTf6-sXJlnvkuXVRgxg3xvYpj4', 'gR4XoVW7hSEMPA_jP_bvkrS_2SnpBVUAchPkoTpchsQ', 'z9xpneGRR_gMuof99KwQ0aBo5GP8exJV6AwlvAvYUYI']
  },
  wx8a8685b900497024: {
    frendHelp: ['QyMnn4PYB3LKRZVbL5jZU4nfK0DBV6UgxnTqzhhSla8', '72-PYbHimPz2NAG8I3-QoHlkMqG8zV5_ZQeNw2gTSJM', '-6AupZnlg2ggfKeVZBhIQ5pGvcC3nOsXLEZhtvGnCDE'],
    materialGet: ['-WQ_qJYbuNtRgBpFI-uomNRszkywd-8AzLDh93PbpU0', 'Gesdm5XxRqr0fIXiQbHZ7sJykejidLnOe-rkxK_j_4k', 'wRNSTZa6f7BYTe1ldyHVHfNazd50QkXI5wGTbMViQN8']
  },
  wxb10430ef4a992cd6: {
    frendHelp: ['yp_7aI5JjPyL2FiElYz_iyraP7dnRa7kXpvOQblq28k', '9Im-Jh06qki6DFH3c485yMsk7hVzLfQdNQ7r9uh5OD4', 'uO7XpCY2mbcgA0JpsB_usaSfYvWlsWSXjVDb5MF187Q'],
    materialGet: ['qPFD4nMJvWR2gy5MfrJod0fk29af0gNYyaZpnNXRQL4', 'H59tijuhkbYqcRnU6m95hPLL-igKnWF9LUXaaGceahI', 'Y1cQ8nkuU-FoRQr0ANm5xEuwn1uaeIkjxJou_dvYw2I']
  },
  wxcecb212ffd10a396: {
    frendHelp: ['2uAUgfxg5uufAc4FyYKttO4kiNk-bI4XIQZINOyeDJc', 'unnAzaCQgvBjftJec7aOCcv1F_ivjB3-3tWgloebDN4', 'XvSsVTKm4a_6gnhKYd4F7ZERrfcwpu00BC4YvKIUrDc'],
    materialGet: ['0yhC_T29PWsipZaLd_P_ghsEjBFVvrSfsiokL8Trmv8', 'a8Bfig5yie2Ic4L8r7SLF_1wtRwYLFzDRe57oq0cJkw', '0dZCvLg2wqMUZuYM1H8hRk2R5FU7QEM1StM6VLjM3QM']
  },
  wx9de16b14efac62fb: {
    frendHelp: ['QQPE-EqDKYUDAJ7OkljkK2pTaCLXSn7Z8_L_6OWGHyg', 'KybWUqDolCV5P-0ajj2kY9PyB9w-UN9TPMOLmYqSMKY', '6Gzq8aJnqWYBluYXFQdh_m5RfcR2Om61N3f4sVmxAJI'],
    materialGet: ['PQkB70m1aJ677AgxGMEHRS7q3QP63u3FYk1qWXojSNk', 'zEhePm_XIfKgXbE5tpluWWL-4yHP_IXa83G7znjlx0A', 'By7pZr_OIf7pZcV-I3StSdrzRxCiFb4PWofC484JGHU']
  },
  appid: {
    frendHelp: ['', '', ''],
    materialGet: ['', '', ''],
    friendsHelpAssistance: ['', '', ''],
    couponGet: ['', '', '']
  }
};